import React from 'react';
import {useLandingPagesContext} from '@dazn/lp-web/src/contexts/LandingPageContext';
import {getButtonLabel} from '@dazn/lp-web/src/components/ComingUpRail/comingUp.utils';
import {getCountdownDiscount} from '@dazn/lp-web/src/components/Countdown/countdown.utils';
import useScrollPosition from '@dazn/lp-web/src/hooks/useScrollPosition';
import {useMedia} from '@dazn/lp-web/src/hooks/useMedia';
import {
    CountdownBox,
    CountdownButton,
    CountdownPriceBadge,
    CountdownTimer
} from '@dazn/lp-web/src/components/Countdown';
import styles from '@dazn/lp-web/src/components/Countdown/countdown.module.css';
import {useCountdown} from '@dazn/lp-web/src/hooks/useCountdown';
import {ICountdownProps} from '@dazn/lp-web/src/types';
import {triggerElementClick} from '@dazn/lp-web/src/analytics/fe-events';
import {elementClickEventTypes} from '@dazn/lp-web/src/analytics/fe-events/elementClick';
import {FOOTER_ID} from '@dazn/lp-web/src/constants/footer.constants';

export const Countdown: React.FC<ICountdownProps> = ({data}) => {
    const {offers, promoOffers, multiplePromoOffers} = useLandingPagesContext();

    const discountAndPrice = getCountdownDiscount({
        data,
        offers,
        promoOffers,
        multiplePromoOffers
    });

    const buttonLabel = data?.button
        ? getButtonLabel(data?.button, offers)
        : '';
    const timer = useCountdown(data?.targetTime);
    const scrollHeight = useScrollPosition();
    const {isDesktop, isMobile, isTab} = useMedia();
    const isFooterComponent = document.getElementById(FOOTER_ID);

    if (scrollHeight === null || (timer && timer.isTimerEnded)) {
        return null;
    }

    if (
        ((isDesktop || isTab) && scrollHeight >= 0 && scrollHeight < 750) ||
        (isMobile && scrollHeight >= 0 && scrollHeight < 535)
    ) {
        return null;
    }

    const handleButtonClick = () => {
        if (data?.button?.action) {
            triggerElementClick({
                section: elementClickEventTypes.STICKY,
                itemId: data?.button?.buttonTrackingId,
                resourceString: data?.button?.label
            });
            data?.button?.action();
        }
    };

    if (isFooterComponent && (isDesktop || isTab)) {
        isFooterComponent.style.paddingBottom = '150px';
    }

    if (isMobile) {
        return (
            <div
                id="countdown-mobile-component"
                className={styles.countdownMobileComponent}
                onClick={handleButtonClick}
            >
                <CountdownTimer
                    hideCountdownZero={data?.hideCountdownZero}
                    timer={timer}
                    units={data?.units}
                    variant="V1"
                />
                <div className={styles.countdownMobileBadgeButtonContainer}>
                    <CountdownPriceBadge
                        badgeText={data?.badgeText}
                        discountAndPrice={
                            discountAndPrice
                                ? discountAndPrice
                                : {price: data?.price}
                        }
                    />
                    {data?.button && (
                        <CountdownButton
                            label={buttonLabel}
                            className={styles.countdownButton}
                            icon={data?.buttonStartIcon?.src}
                            onlyIcon
                        />
                    )}
                </div>
            </div>
        );
    }

    return (
        <div id="countdown-component" className={styles.countdownComponent}>
            <CountdownBox onClick={handleButtonClick} data={data}>
                <CountdownTimer
                    hideCountdownZero={data?.hideCountdownZero}
                    timer={timer}
                    units={data?.units}
                    variant="V1"
                />
                <CountdownPriceBadge
                    title={data?.title}
                    badgeText={data?.badgeText}
                    discountAndPrice={
                        discountAndPrice
                            ? discountAndPrice
                            : {price: data?.price}
                    }
                />
                {buttonLabel && (
                    <CountdownButton
                        label={buttonLabel}
                        className={styles.countdownButton}
                    />
                )}
            </CountdownBox>
        </div>
    );
};
